import { useKeycloak } from "@react-keycloak/web";
import { useState } from "react";
import { Navbar, Container, Dropdown } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import logo from "../assets/images/logo1.png";
import { getVmcCount } from "../services/api/vmc";
import { useTranslation } from 'react-i18next';
import { siteFilterStorageKeys } from "../hooks/overviewFilters";

const Navb = () => {

  const { keycloak } = useKeycloak();
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [vmcCount, setVmcCount] = useState(0);
  const [firstTime, setFirstTime] = useState(true);
  const [expanded, setExpanded] = useState(false);

  const token = keycloak.token || '';

  if (token && firstTime) {
    getVmcCount(token).then((count) => setVmcCount(+count));
    setFirstTime(false);
  }

  const closeHamburgerMenu = () => {
    setExpanded(false);
  };

  const handleCleanup = () => {
    // your cleanup logic if needed
  };

  const isActive = (path: string) => "";

  const revenueSubMenu = (
      <>
      <Dropdown.Item as={Link} className={`${isActive("/dashboard/lists/profit")} nav-link`} to="/dashboard/lists/profit" onClick={closeHamburgerMenu}>
        &nbsp;&nbsp;{t("omzetOverzicht")}
      </Dropdown.Item>
      <Dropdown.Item as={Link} className={`${isActive("/dashboard/lists/productSales")} nav-link`} to="/dashboard/lists/productSales" onClick={closeHamburgerMenu}>
        &nbsp;&nbsp;{t("omzetRapport")}
      </Dropdown.Item>
      </>
  );

  const settingsSubMenu = (
      <>
      <Dropdown.Item as={Link} className={`${isActive("/dashboard/lists/sites")} nav-link`} to="/dashboard/lists/sites" onClick={closeHamburgerMenu}>
        &nbsp;&nbsp;{t("sites")}
      </Dropdown.Item>
      <Dropdown.Item as={Link} className={`${isActive("/dashboard/lists/products")} nav-link`} to="/dashboard/lists/products" onClick={closeHamburgerMenu}>
        &nbsp;&nbsp;{t("producten")}
      </Dropdown.Item>
      <Dropdown.Item as={Link} className={`${isActive("/dashboard/lists/terminals")} nav-link`} to="/dashboard/lists/terminals" onClick={closeHamburgerMenu}>
        &nbsp;&nbsp;{t("terminals")}
      </Dropdown.Item>
      <Dropdown.Item as={Link} className={`${isActive("/dashboard/lists/locations")} nav-link`} to="/dashboard/lists/locations" onClick={closeHamburgerMenu}>
        &nbsp;&nbsp;{t("locaties")}
      </Dropdown.Item>
      <Dropdown.Item as={Link} className={`${isActive("/dashboard/lists/alertDefinitions")} nav-link`} to="/dashboard/lists/alertDefinitions" onClick={closeHamburgerMenu}>
        &nbsp;&nbsp;{t("alarmdefinities")}
      </Dropdown.Item>
      {vmcCount > 0 && (
        <Dropdown.Item as={Link} className={`${isActive("/dashboard/lists/vmcs")} nav-link`} to="/dashboard/lists/vmcs" onClick={closeHamburgerMenu}>
          &nbsp;&nbsp;{t("automaten")}
        </Dropdown.Item>
      )}
      </>
  );

  return (
    <Navbar expand="lg" className="nav iq-navbar" expanded={expanded} onToggle={setExpanded}>
      <Container fluid style={{ paddingLeft: "var(--bs-gutter-x, 0.5rem)" }}>
        <Navbar.Toggle aria-controls="navbarSupportedContent">
          <span className="navbar-toggler-icon">
            <span className="navbar-toggler-bar bar1 mt-2"></span>
            <span className="navbar-toggler-bar bar2"></span>
            <span className="navbar-toggler-bar bar3"></span>
          </span>
        </Navbar.Toggle>

        <Navbar.Brand as="div" className="ms-auto navbar-list mb-lg-0">
          <Link
            to="/dashboard"
            onClick={() => {
              const siteFilter = siteFilterStorageKeys().map((key) => [key, localStorage.getItem(key)] as const);
              localStorage.clear();
              siteFilter.forEach(([key, value]) => value !== null && localStorage.setItem(key, value));
            }}
          >
            <img src={logo} alt="logo" className="img-fluid p-0 flex-column" />
          </Link>
        </Navbar.Brand>

        <Navbar.Collapse id="navbarSupportedContent" className="col-md-2 ms-auto align-items-start">
          <ul className="navbar-nav ms-auto">
            <Dropdown as="li" className="item-name">
              <Dropdown.Toggle as="div" id="revenueDropdown">
                <div className={`${isActive("/dashboard/lists/profit")} nav-link menuItem`}>
                  {t("omzet")}
                </div>
              </Dropdown.Toggle>

              <Dropdown.Menu className="settings-menu">
                {revenueSubMenu}
              </Dropdown.Menu>
            </Dropdown>

            <li className="item-name">
              <Link className={`${isActive("/dashboard/lists/alerts")} nav-link d-sm-none h3 menuItem`} to="/dashboard/lists/alerts" onClick={() => { closeHamburgerMenu(); handleCleanup(); }}>
                {t("alarmen")}
              </Link>
              <Link className={`${isActive("/dashboard/lists/alerts")} nav-link d-none d-sm-block menuItem`} to="/dashboard/lists/alerts" onClick={() => { closeHamburgerMenu(); handleCleanup(); }}>
                {t("alarmen")}
              </Link>
            </li>

            <li className="item-name">
              <Link className={`${isActive("/dashboard/lists/transactions")} nav-link d-sm-none h3 menuItem`} to="/dashboard/lists/transactions" onClick={() => { closeHamburgerMenu(); handleCleanup(); }}>
                {t("transacties")}
              </Link>
              <Link className={`${isActive("/dashboard/lists/transactions")} nav-link d-none d-sm-block menuItem`} to="/dashboard/lists/transactions" onClick={() => { closeHamburgerMenu(); handleCleanup(); }}>
                {t("transacties")}
              </Link>
            </li>

            <Dropdown as="li" className="item-name">
              <Dropdown.Toggle as="div" id="navbarDropdown">
                <div className={`${isActive("/dashboard/menu/settings")} nav-link menuItem`}>
                  {t("instellingen")}
                </div>
              </Dropdown.Toggle>

              <Dropdown.Menu className="settings-menu">
                {settingsSubMenu}
              </Dropdown.Menu>
            </Dropdown>

            <div
              className="item-name"
              style={{ cursor: "pointer" }}
              onClick={() => {
                closeHamburgerMenu();
                keycloak.authenticated ? keycloak.logout() : keycloak.login();
              }}
            >
              <li className="nav-link d-sm-none h3">{t("logout")}</li>
              <li className="nav-link d-none d-sm-block">{t("logout")}</li>
            </div>
          </ul>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Navb;